import React, { useEffect, useReducer, useState } from 'react'
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AccountReducer, { initialStateAuth } from '../../../Shared-ui/Store/AuthReducer/AuthReducer';

const NotFound = () => {
    const navigate = useNavigate();
    const [state, dispatch] = useReducer(AccountReducer, initialStateAuth);
    const [previousPage, setPreviousPage] = useState('/')
    useEffect(()=>{
      if(state.isLogin) setPreviousPage('/home')
    },[])
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          textAlign: 'center',
          backgroundColor: '#f5f5f5',
        }}
      >
        <Typography variant="h1" color="primary" gutterBottom>
          404
        </Typography>
        <Typography variant="h6" color="textSecondary" gutterBottom>
          Oops! Page not found
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          The page you are looking for might have been moved or does not exist.
        </Typography>
        <Button variant="contained" color="primary" onClick={()=>  navigate(previousPage)}>
          Go Back to Home
        </Button>
      </Box>
    );
}

export default NotFound